var BASWebServices;
(function (BASWebServices) {
    var WebServiceResonseLinkMulti = (function () {
        function WebServiceResonseLinkMulti(xmlString) {
            this.downloadLinkList = {};
            xmlString = xmlString.replace(/\<div.+\'\>/g, '');
            xmlString = xmlString.replace(/\<\/div.*\>/g, '');
            var xmlParsed = $.parseXML(xmlString);
            var nl = xmlParsed.firstChild.childNodes;
            this.builder(nl);
        }
        WebServiceResonseLinkMulti.prototype.builder = function (xmlStringParsed) {
            for (var i = 0; i < xmlStringParsed.length; i++) {
                var currentNode = xmlStringParsed[i];
                var currentNodeName = currentNode.nodeName;
                switch (currentNodeName) {
                    case 'success':
                        var currentVal = currentNode.textContent;
                        if (currentVal == "true")
                            this.success = true;
                        else
                            this.success = false;
                        break;
                    case 'fileList':
                        var allEntrys = currentNode.innerHTML.split("</entry>");
                        for (var j = 0; j < allEntrys.length; j++) {
                            var currEntry = allEntrys[j].replace("<entry>", "");
                            if (currEntry != "") {
                                var allInfo = currEntry.split("</key>");
                                if (allInfo.length != 2)
                                    console.error("There can not be more than two entries, after we split this xml part");
                                var key = allInfo[0].replace("<key>", "");
                                var value = allInfo[1].replace("<value>", "").replace("</value>", "");
                                this.downloadLinkList[key] = value;
                            }
                        }
                        break;
                    case 'message':
                        this.output = currentNode.textContent;
                        break;
                    case 'warnings':
                        this.warnings = currentNode.textContent;
                        break;
                    default:
                        console.error("This should not had happened. In WebServiceResponsLink there is no value " + currentNodeName + " this is an error");
                }
            }
        };
        WebServiceResonseLinkMulti.prototype.toString = function () {
            var resString = "";
            resString += "Val: " + this.success + " | ";
            resString += "downloadLinkList: " + this.downloadLinkList + " | ";
            resString += "output: " + this.output + " | ";
            resString += "warnings: " + this.warnings + " \n";
            return resString;
        };
        return WebServiceResonseLinkMulti;
    }());
    BASWebServices.WebServiceResonseLinkMulti = WebServiceResonseLinkMulti;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=WebServiceResponseLinkMulti.js.map